<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder" (pointerover)="opItemHover($event)" (pointerleave)="opMenuVerlaten()">
    <ul class="dl-nodemenu">
        @if (correspondentieType === 'qs') {
            @if (!condtag || node.data('condstate') === condtag.state) {
                <li class="dl-nodemenu__item" data-uitleg="correspondence_qs_directed" (click)="uitvoerChangeAction({type:'correspondence_qs_directed'})" title="{{ 'ADD_CORR_DIRECTED' | translate }}">
                    <a class="correspondence_directed"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_qs_normal" (click)="uitvoerChangeAction({type:'correspondence_qs_normal'})" title="{{ 'ADD_CORR_NORMAL' | translate }}">
                    <a class="correspondence_normal"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_qs_directed_reverse" (click)="uitvoerChangeAction({type:'correspondence_qs_directed_reverse'})" title="{{ 'ADD_CORR_DIR_REV' | translate }}">
                    <a class="correspondence_directed_reverse"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_qs_reverse" (click)="uitvoerChangeAction({type:'correspondence_qs_reverse'})" title="{{ 'ADD_CORR_REV' | translate }}">
                    <a class="correspondence_reverse"></a>
                </li>
            }
        }
        @if (correspondentieType === 'qv') {
            @if (!condtag || node.data('condstate') === condtag.state) {
                <li class="dl-nodemenu__item" data-uitleg="correspondence_qv_directed" (click)="uitvoerChangeAction({type:'correspondence_qv_directed'})" title="{{ 'ADD_CORR_DIRECTED' | translate }}">
                    <a class="correspondence_directed"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_qv_normal" (click)="uitvoerChangeAction({type:'correspondence_qv_normal'})" title="{{ 'ADD_CORR_NORMAL' | translate }}">
                    <a class="correspondence_normal"></a>
                </li>
            }
        }
        @if (correspondentieType === 'dqs') {
            @if (!condtag || node.data('condstate') === condtag.state) {
                <li class="dl-nodemenu__item" data-uitleg="correspondence_dqs_directed" (click)="uitvoerChangeAction({type:'correspondence_dqs_directed'})" title="{{ 'ADD_CORR_DIRECTED' | translate }}">
                    <a class="correspondence_directed"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_dqs_normal" (click)="uitvoerChangeAction({type:'correspondence_dqs_normal'})" title="{{ 'ADD_CORR_NORMAL' | translate }}">
                    <a class="correspondence_normal"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_dqs_directed_reverse" (click)="uitvoerChangeAction({type:'correspondence_dqs_directed_reverse'})" title="{{ 'ADD_CORR_DIR_REV' | translate }}">
                    <a class="correspondence_directed_reverse"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_dqs_reverse" (click)="uitvoerChangeAction({type:'correspondence_dqs_reverse'})" title="{{ 'ADD_CORR_REV' | translate }}">
                    <a class="correspondence_reverse"></a>
                </li>
            }
        }
        @if (correspondentieType === 'dv') {
            @if (!condtag || node.data('condstate') === condtag.state) {
                <li class="dl-nodemenu__item" data-uitleg="correspondence_dv_directed" (click)="uitvoerChangeAction({type:'correspondence_dv_directed'})" title="{{ 'ADD_CORR_DIRECTED' | translate }}">
                    <a class="correspondence_directed"></a>
                </li>
                <li class="dl-nodemenu__item" data-uitleg="correspondence_dv_normal" (click)="uitvoerChangeAction({type:'correspondence_dv_normal'})" title="{{ 'ADD_CORR_NORMAL' | translate }}">
                    <a class="correspondence_normal"></a>
                </li>
            }
        }
        @if (!condtag || node.data('condstate') === condtag.state) {
            <li class="dl-nodemenu__item" (click)="uitvoerSwitchArgs()" title="{{ 'SWITCH_ARGS' | translate }}">
                <a class="switch_args"></a>
            </li>
        }
        <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
        <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
            <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
        </li>
    </ul>
</div>
